module.exports = __webpack_public_path__ + "img/quattro.6f255b6e.png";